import { render, staticRenderFns } from "./RouteStopsEditor.vue?vue&type=template&id=45a4c3d6&scoped=true&"
import script from "./RouteStopsEditor.vue?vue&type=script&lang=ts&"
export * from "./RouteStopsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./RouteStopsEditor.vue?vue&type=style&index=0&id=45a4c3d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a4c3d6",
  null
  
)

export default component.exports